export type Position = 'left' | 'right'

export const MIN_WIDTH = 200
